module.exports = __webpack_public_path__ + "static/media/google9.fb021213.png";